<template>
  <div class="animated fadeIn">
    <b-form v-on:submit.prevent="submitHandling">
      <b-card header="게임 수정">
        <b-card header="게임 설정">
          <b-media>
            <div slot="aside" :class="labelClasses + ' columnWidth font-weight-bold'">
              앱 마스터 ID
            </div>
            <p>
              {{ playGameWithMoment.appMasterId }}
            </p>
          </b-media>

          <b-media>
            <div slot="aside" :class="labelClasses + ' columnWidth font-weight-bold'">
              앱이름(KR)
            </div>
            <p>
              {{ playGameWithMoment.appNameInfo.ko }}
            </p>
          </b-media>

          <b-media>
            <div slot="aside" :class="labelClasses + ' columnWidth font-weight-bold'">
              앱아이콘
            </div>
            <div style="width: 300px;">
              <vue-dropzone ref="appIcon" id="appIcon" :options="Object.assign({}, JSON.parse(JSON.stringify(dropzoneOptions)), {clickable: ['#appIcon', '#appIconUploadBtn'], maxFilesize: 0.1, withCredentials: true, renameFile: renameAndSetDtoProperty.bind(this, { imageObj: 'gameViewInfo', name: 'appIcon' }), accept: acceptHandlingForDimensionLimit.bind(this, 228, 228, '앱아이콘')})"
                            v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-success="imgSuccessHandling"  v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-sending="$refs['appIcon'].removeAllFiles(false);$refs['appIcon'].setOption('maxFiles', null)" class="mb-2"></vue-dropzone>
            </div>
            <p>* 사이즈: 228*228 / 용량은 100KB이하로 등록해주세요.</p>
            <b-button type="button" id="appIconUploadBtn">upload</b-button>
            <b-button type="button" :href="playGameWithMoment.gameViewInfo.appIcon" target="_blank" v-show="playGameWithMoment.gameViewInfo.appIcon" class="ml-3">download</b-button>
          </b-media>

          <b-form-group
                  label="공식사이트"
                  label-for="siteUrl"
                  :label-class="labelClasses+` columnWidth`"
                  horizontal>
            <b-form-checkbox id="isUseSite"
                             v-model="isUseSite">
              사용
            </b-form-checkbox>
            <span v-show="isUseSite">
                  <b-form-input id="siteUrl" type="text" :state="checkSiteUrlValid" v-model="playGameWithMoment.gameViewInfo.siteUrl" autocomplete="url" :class="` d-inline-block w-50 align-middle mr-1`" placeholder="http:// 혹은 https://로 시작하도록 등록 부탁드립니다."></b-form-input>
                  <b-button type="button" class="btn btn-sm btn-secondary" :href="playGameWithMoment.gameViewInfo.siteUrl" target="_blank">확인</b-button>
                </span>
          </b-form-group>

          <b-form-group
                  label="등급(연령)"
                  label-for="age"
                  :label-class="labelClasses+` zzz`"
                  horizontal>
            <b-form-select v-model="playGameWithMoment.gameViewInfo.grade"
                           required
                           :options="gameGradeOptionsForBootstrap" style="width: 200px;">
            </b-form-select>
          </b-form-group>

          <b-form-group
                  label="체험플레이 스낵게임 연결"
                  label-for="isUseSnackGameExeUrl"
                  :label-class="labelClasses+` zzz`"
                  horizontal>
            <b-form-checkbox id="isUseSnackGameExeUrl"
                             v-model="isUseSnackExeUrl">
              사용
            </b-form-checkbox>
            <span v-show="isUseSnackExeUrl">
                  <b-form-input id="snackExeUrl" type="text" :state="checkSnackExeUrlValid" v-model="playGameWithMoment.gameViewInfo.snackGameExeUrl" autocomplete="url" :class="` d-inline-block w-50 align-middle mr-1`" placeholder="http:// 혹은 https://로 시작하도록 등록 부탁드립니다."></b-form-input>
                  <b-button type="button" class="btn btn-sm btn-secondary" :href="playGameWithMoment.gameViewInfo.snackGameExeUrl" target="_blank">확인</b-button>
                </span>
          </b-form-group>

          <b-form-group
                  label="카톡메시지 이미지"
                  label-for="kakaoTalkShareImage"
                  :label-class="labelClasses+` zzz`"
                  horizontal>
            <div style="width: 300px;">
              <vue-dropzone ref="kakaoTalkShareImage" id="kakaoTalkShareImage" :options="Object.assign({}, JSON.parse(JSON.stringify(dropzoneOptions)), { clickable: ['#kakaoTalkShareImage', '#kakaoTalkShareUploadBtn'], withCredentials: true, renameFile: renameAndSetDtoProperty.bind(this, { imageObj: 'gameViewInfo', name: 'kakaoTalkShareImage' }), accept: acceptHandlingForDimensionLimit.bind(this, 720, 630, '카카오톡 공유')})"
                            v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-success="imgSuccessHandling" v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-sending="$refs['kakaoTalkShareImage'].removeAllFiles(false);$refs['kakaoTalkShareImage'].setOption('maxFiles', null)" class="mb-2"></vue-dropzone>
              <p>* 사이즈: 720*630 / 용량은 200KB이하로 등록해주세요.</p>
              <b-button type="button" id="kakaoTalkShareUploadBtn">upload</b-button>
              <b-button type="button" :href="playGameWithMoment.gameViewInfo.kakaoTalkShareImage" v-if="playGameWithMoment.gameViewInfo.kakaoTalkShareImage" class="ml-3" target="_blank">download</b-button>
            </div>
          </b-form-group>

          <b-form-group
                  label="페이스북 공유 이미지"
                  label-for="facebookShareImage"
                  :label-class="labelClasses+` zzz`"
                  horizontal>
            <div style="width: 300px;">
              <!--accept: acceptHandlingForDimensionLimit.bind(this, 1200, 630, '페이스북 공유')-->
              <!--v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension"-->
              <vue-dropzone ref="facebookShareImage" id="facebookShareImage" :options="Object.assign({}, JSON.parse(JSON.stringify(dropzoneOptions)), { clickable: ['#facebookShareImage', '#facebookShareUploadBtn'], withCredentials: true, maxFilesize: 1.0, renameFile: renameAndSetDtoProperty.bind(this, { imageObj: 'gameViewInfo', name: 'facebookShareImage' }), accept: acceptHandlingForDimensionLimitByObj.bind(this, [{ width: 1200, height: 630 }, {width: 1200, height: 628}, {width: 1800, height: 942}], '페이스북 공유 이미지')})"
                            v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-success="imgSuccessHandling" v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-sending="$refs['facebookShareImage'].removeAllFiles(false);$refs['facebookShareImage'].setOption('maxFiles', null)" class="mb-2"></vue-dropzone>
              <p>* 사이즈: 1200*630 / 용량은 200KB이하로 등록해주세요.</p>
              <b-button type="button" id="facebookShareUploadBtn">upload</b-button>
              <b-button type="button" :href="playGameWithMoment.gameViewInfo.facebookShareImage" v-if="playGameWithMoment.gameViewInfo.facebookShareImage" class="ml-3" target="_blank">download</b-button>
            </div>
          </b-form-group>

          <b-form-group
                  label="친구수 노출"
                  label-for="isExposingFriends"
                  :label-class="labelClasses+` zzz`"
                  horizontal>
            <b-form-checkbox id="isExposingFriends"
                             v-model="playGameWithMoment.gameViewInfo.hasAuthOfFriends">
              사용
            </b-form-checkbox>
          </b-form-group>

        <!--<b-button type="button" @click="test">테스트 </b-button>-->
        </b-card>

        <b-card header="출시 전 해당 게임ID로 게임상세페이지 접근시 안내 문구">
          <b-form-textarea v-model="playGameWithMoment.gameViewInfo.notLaunchingMsg"
                           :rows="3"
                           :max-rows="5" style="width: 400px;">
          </b-form-textarea>
          <p class="mb-0">* OS 1개라도 노출설정(출시)이 된 경우에는 해당 팝업의 문구가 노출되지 않습니다.</p>
          <p class="mb-0">* 특정 OS에만 미노출설정(미출시)인 경우에는 게임상세화면이 노출되고 해당OS 출시준비중으로 안내됩니다.</p>
          <p class="mb-0">* (AOS만 출시한 게임이   iOS에서 노출시 게임상세페이지가 노출되고 ‘게임하기’버튼이 ‘출시준비중’으로 바뀌고 비활성화처리)</p>
        </b-card>

        <b-card header="게임하러가기 버튼 링크">
          <div v-for="(obj, market) in this.playGameWithMoment.marketInfo" :key="market">

            <b-form-group
                :label="market"
                :label-for="market + '-info'"
                :label-class="labelClasses+` columnWidth`"
                horizontal>
              <b-form-checkbox :id="'marketLinkUrl' + market"
                               @change="changeIsOutLinkUrl(market, $event)"
                               v-model="isOutLinkUrl[market]">
                외부 링크 사용
              </b-form-checkbox>
              <span v-show="isOutLinkUrl[market]">
                <b-form-input :id="'outLinkUrl' + market" type="text" v-model="obj.outLinkUrl" autocomplete="url" :class="` d-inline-block w-50 align-middle mr-1`" placeholder="http:// 혹은 https://로 시작하도록 등록 부탁드립니다."></b-form-input>
                <b-button type="button" class="btn btn-sm btn-secondary" :href="obj.outLinkUrl" target="_blank">확인</b-button>
                <b-form-radio-group label="test" v-model="obj.outLinkType" v-if="false">
                  <b-form-radio value="">없음</b-form-radio>
                  <b-form-radio value="oneStore">원스토어</b-form-radio>
                </b-form-radio-group>
              </span>
            </b-form-group>
          </div>
        </b-card>

        <template v-if="hasAuthOfExposure()">
          <b-card header="OS 노출설정">
            <b-form-group label="노출 OS선택">
              <b-form-checkbox-group v-model="osSelected" :options="osOptions">
              </b-form-checkbox-group>
            </b-form-group>
          </b-card>

          <b-card header="AOS 노출설정" v-if="playGameWithMoment.aos !== null">
            <b-form-group
                    label="게임출시일"
                    label-for="aosStartTime"
                    :label-class="labelClasses+` columnWidth`"
                    horizontal>
              <date-picker id="aosStartTime" :value="playGameWithMoment.aos.appStartTime" v-on:input="playGameWithMoment.aos.appStartTime = new Date($event)" :config="dateOptions" class="date_picker" required></date-picker>
            </b-form-group>

            <b-form-group
                    label="노출순서 가출시일 설정"
                    label-for="aosOrderTime"
                    :label-class="labelClasses+` columnWidth`"
                    horizontal>
              <date-picker id="aosOrderTime" :value="playGameWithMoment.aos.orderTime" v-on:input="playGameWithMoment.aos.orderTime = new Date($event)" :config="dateOptions" class="date_picker"></date-picker>
              <p>* 노출우선 가출시일은 모바일게임의 정렬기준이 되며, 출시일이 최근일수록 상위에 정렵됩니다.(default = 등록한 게임출시일)</p>
              <p>* 설정된 가출시일 목록은 아래 메뉴에서 확인하세요. <b-link :to="{name: 'playGameOsTypeList'}">OS 목록 정렬 보기 -> </b-link></p>
            </b-form-group>

            <b-form-group
                    label="게임 노출설정"
                    :label-class="labelClasses+` zzz`"
                    label-for="aosDisplayStartTime" :horizontal="true" :label-cols="1">
              <label class="switch switch-label switch-primary">
                <input class="switch-input" type="checkbox" :checked="playGameWithMoment.aos.displayYn" @change="playGameWithMoment.aos.displayYn = !playGameWithMoment.aos.displayYn">
                <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
              </label>
              <date-picker id="aosDisplayStartTime" :value="playGameWithMoment.aos.displayStartTime" v-on:input="playGameWithMoment.aos.displayStartTime = new Date($event)" :config="dateOptions" class="date_picker" required></date-picker>
            </b-form-group>

            <b-form-group
                    label="아이콘라벨 설정"
                    :label-class="labelClasses+` zzz`"
                    label-for="aosDisplayStartTime" :horizontal="true" :label-cols="1">
              <b-form-select v-model="playGameWithMoment.aos.osViewInfo.iconLabel"
                             :options="iconLabelOptionsForBootstrap" class="date_picker">
              </b-form-select>
              <hr>
              <date-picker class="d-inline-block date_picker" id="aosIconStartTime" :value="playGameWithMoment.aos.osViewInfo.iconStartTime" v-on:input="playGameWithMoment.aos.osViewInfo.iconStartTime = new Date($event)" :config="dateOptions"></date-picker>
              ~
              <date-picker class="d-inline-block date_picker" id="aosIconEndTime" :value="playGameWithMoment.aos.osViewInfo.iconEndTime" v-on:input="playGameWithMoment.aos.osViewInfo.iconEndTime = new Date($event)" :config="aosEndIconLabelOptions"></date-picker>
            </b-form-group>

            <b-form-group
                    label="검색 노출설정"
                    :label-class="labelClasses+` zzz`"
                    label-for="aosDisplayStartTime" :horizontal="true" :label-cols="1">
              <label class="switch switch-label switch-primary">
                <input class="switch-input" type="checkbox" :checked="playGameWithMoment.aos.osViewInfo.searchYn" @change="playGameWithMoment.aos.osViewInfo.searchYn = !playGameWithMoment.aos.osViewInfo.searchYn">
                <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
              </label>
              <p>* 다음과 톡에서 해당 게임 검색여부를 설정합니다. </p>
              <p>* [게임노출설정 on] AND [검색노출설정 on]일 경우 다음/톡에서 검색되며, 둘 중 하나라도 off일 경우 검색에서 제한됩니다. </p>
            </b-form-group>
          </b-card>

          <b-card header="iOS 노출설정" v-if="playGameWithMoment.ios !== null">
            <b-form-group
                    label="게임출시일"
                    label-for="iosStartTime"
                    :label-class="labelClasses+` columnWidth`"
                    horizontal>
              <date-picker id="iosStartTime" :value="playGameWithMoment.ios.appStartTime" v-on:input="playGameWithMoment.ios.appStartTime = new Date($event)" :config="dateOptions" class="date_picker" required></date-picker>
            </b-form-group>

            <b-form-group
                    label="노출순서 가출시일 설정"
                    label-for="iosOrderTime"
                    :label-class="labelClasses+` columnWidth`"
                    horizontal>
              <date-picker id="iosOrderTime" :value="playGameWithMoment.ios.orderTime" v-on:input="playGameWithMoment.ios.orderTime = new Date($event)" :config="dateOptions" class="date_picker"></date-picker>
              <p>* 노출우선 가출시일은 모바일게임의 정렬기준이 되며, 출시일이 최근일수록 상위에 정렵됩니다.(default = 등록한 게임출시일)</p>
              <p>* 설정된 가출시일 목록은 아래 메뉴에서 확인하세요. <b-link :to="{name: 'playGameOsTypeList'}">OS 목록 정렬 보기 -> </b-link></p>
            </b-form-group>

            <b-form-group
                    label="게임 노출설정"
                    :label-class="labelClasses+` zzz`"
                    label-for="iosDisplayStartTime" :horizontal="true" :label-cols="1">
              <label class="switch switch-label switch-primary">
                <input class="switch-input" type="checkbox" :checked="playGameWithMoment.ios.displayYn" @change="playGameWithMoment.ios.displayYn = !playGameWithMoment.ios.displayYn">
                <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
              </label>
              <date-picker id="iosDisplayStartTime" :value="playGameWithMoment.ios.displayStartTime" v-on:input="playGameWithMoment.ios.displayStartTime = new Date($event)" :config="dateOptions" class="date_picker" required></date-picker>
            </b-form-group>

            <b-form-group
                    label="아이콘라벨 설정"
                    :label-class="labelClasses+` zzz`"
                    label-for="iosDisplayStartTime" :horizontal="true" :label-cols="1">
              <b-form-select v-model="playGameWithMoment.ios.osViewInfo.iconLabel"
                             :options="iconLabelOptionsForBootstrap" class="date_picker">
              </b-form-select>
              <hr>
              <date-picker class="d-inline-block date_picker" id="iosIconStartTime" :value="playGameWithMoment.ios.osViewInfo.iconStartTime" v-on:input="playGameWithMoment.ios.osViewInfo.iconStartTime = new Date($event)" :config="dateOptions"></date-picker>
              ~
              <date-picker class="d-inline-block date_picker" id="iosIconEndTime" :value="playGameWithMoment.ios.osViewInfo.iconEndTime" v-on:input="playGameWithMoment.ios.osViewInfo.iconEndTime = new Date($event)" :config="iosEndIconLabelOptions"></date-picker>
            </b-form-group>

            <b-form-group
                    label="검색 노출설정"
                    :label-class="labelClasses+` zzz`"
                    label-for="iosDisplayStartTime" :horizontal="true" :label-cols="1">
              <label class="switch switch-label switch-primary">
                <input class="switch-input" type="checkbox" :checked="playGameWithMoment.ios.osViewInfo.searchYn" @change="playGameWithMoment.ios.osViewInfo.searchYn = !playGameWithMoment.ios.osViewInfo.searchYn">
                <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
              </label>
              <p>* 다음과 톡에서 해당 게임 검색여부를 설정합니다. </p>
              <p>* [게임노출설정 on] AND [검색노출설정 on]일 경우 다음/톡에서 검색되며, 둘 중 하나라도 off일 경우 검색에서 제한됩니다. </p>
            </b-form-group>
          </b-card>
        </template>
        <b-card header="게임 컨텐츠정보 설정 (국가별 언어설정)">
          <b-tabs>
            <b-tab :title="lang" v-for="(value, lang) in playGameWithMoment.appNameInfo" :active="lang==='ko'" :key="'gameSpecView'+lang" v-if="value !== null">
              <b-media>
                <div slot="aside" :class="labelClasses + ' columnWidth font-weight-bold'">
                  게임명
                </div>
                <p>
                  {{ playGameWithMoment.appNameInfo[lang] }}
                </p>
              </b-media>

              <b-media>
                <div slot="aside" :class="labelClasses + ' columnWidth font-weight-bold'">
                  장르
                </div>
                <p>
                  {{ genreDesc[playGameWithMoment.genre] ? genreDesc[playGameWithMoment.genre][lang] : 'unknwon' }}
                </p>
              </b-media>

              <b-form-group
                      label="개발사명"
                      :label-for="'partnerName' +lang"
                      :label-class="labelClasses+` zzz`"
                      invalid-feedback="게임을 선택하세요."
                      horizontal>
                <b-form-input :id="'partnerName' +lang"
                              v-model="playGameWithMoment.gameViewInfo.partnerName[lang]"
                              class="d-inline-block w-50" placeholder=""></b-form-input>
              </b-form-group>

              <b-form-group
                      label="한줄설명"
                      :label-for="'shortDesc' +lang"
                      :label-class="labelClasses+` zzz`"
                      invalid-feedback="게임을 선택하세요."
                      horizontal>
                <b-form-input :id="'shortDesc' +lang"
                              v-model="playGameWithMoment.gameViewInfo.shortDesc[lang]"
                              class="d-inline-block w-50" placeholder=""></b-form-input>
              </b-form-group>

              <b-form-group
                      label="게임설명"
                      :label-for="'longDesc' +lang"
                      :label-class="labelClasses+` zzz`"
                      invalid-feedback="게임을 선택하세요."
                      horizontal>
                <b-form-textarea :id="'longDesc' +lang" v-model="playGameWithMoment.gameViewInfo.longDesc[lang]"
                                 :rows="6"
                                 :max-rows="6">
                </b-form-textarea>
              </b-form-group>

              <b-form-group
                      label="게임동영상"
                      :label-for="'mediaLink' +lang"
                      :label-class="labelClasses+` zzz`"
                      invalid-feedback="게임을 선택하세요."
                      horizontal>
                <input :id="'mediaKakao' +lang" type="radio" value="kakaotv" v-model="mediaSelected[lang]" @change="playGameWithMoment.gameViewInfo.mediaLink[lang] = ''">
                <label :for="'mediaKakao' +lang" class="ml-1">카카오TV 사용</label>
                <input type="text" v-model="playGameWithMoment.gameViewInfo.mediaLink[lang]" v-show="mediaSelected[lang] === 'kakaotv'" class="ml-1" style="width: 400px;" placeholder="공유 url을 입력해주세요.">

                <span class="ml-3">
                <input :id="'mediaYoutube' +lang" type="radio" value="youtube" v-model="mediaSelected[lang]" @change="playGameWithMoment.gameViewInfo.mediaLink[lang] = '' ">
                <label :for="'mediaYoutube' +lang" class="ml-1">유투브 사용</label>
              </span>
                <input type="text" v-model="playGameWithMoment.gameViewInfo.mediaLink[lang]" v-show="mediaSelected[lang] === 'youtube'" class="ml-1" style="width: 400px;" placeholder="공유 url을 입력해주세요.">

                <span class="ml-3">
                <input :id="'mediaNone' +lang" type="radio" value="none" v-model="mediaSelected[lang]" @change="playGameWithMoment.gameViewInfo.mediaLink[lang] = ''">
                <label :for="'mediaNone' +lang" class="ml-1">없음</label>
              </span>

                <!--<input type="text" v-model="playGameWithMoment.gameViewInfo.mediaLink[lang]" v-show="mediaSelected[lang] === 'kakaotv'" class="ml-1" style="width: 400px;" placeholder="공유 url을 입력해주세요.">-->
              </b-form-group>
              <b-form-group
                      label="스크린샷"
                      :label-for="'screenShot' +lang"
                      :label-class="labelClasses+` zzz`"
                      horizontal>
                <vue-dropzone :ref="'screenShot' +lang" :id="'screenShot' +lang" :options="Object.assign({}, JSON.parse(JSON.stringify(dropzoneOptions)), {clickable: ['#screenShot'+lang, '#screenShotUploadBtn' +lang], maxFiles: 10, maxFilesize: 0.15, withCredentials: true, renameFile: renameAndSetDtoProperty.bind(this, { imageObj: 'gameViewInfo', lang: lang, name: 'screenShot'}), accept: acceptHandlingForDimensionLimitByObj.bind(this, [{ width: 1120, height: 624 }, {width: 600, height: 1066}], '스크린샷')})"
                              v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-success="imgSuccessHandling" v-on:vdropzone-removed-file="imgRemoveScreenshots" class="mb-2"></vue-dropzone>
                <p>* 세로형 : 600 * 1066, 가로형 1120 * 624 / 용량은 150KB이하/1장으로 등록해주세요.</p>
                <b-button type="button" :id="'screenShotUploadBtn'+lang">upload</b-button>
                <ol style="list-style: none">
                  <li v-for="(item, index) in playGameWithMoment.gameViewInfo.screenShot[lang]" :key="'screenShot' +lang+index">
                    <span>{{index+1}}번째 이미지 우선 순위: </span>
                    <input type="text" v-model="item.order">
                    <b-button type="button" :href="item.imageUrl" v-if="item.imageUrl" class="ml-3" target="_blank">download</b-button>
                  </li>
                </ol>
              </b-form-group>
            </b-tab>
          </b-tabs>
        </b-card>

        <b-row class="align-items-center mt-3">
          <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <b-button block variant="outline-primary" type="submit">수정</b-button>
          </b-col>
          <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <b-button block variant="outline-secondary" v-on:click="$router.go(-1)">취소</b-button>
          </b-col>
        </b-row>

      </b-card>
    </b-form>
  </div>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import { MODULE_NAME as PGM_MODULE, FETCH_PLAYGAME } from '@/store/playGame/actions.type'
  import { MODULE_NAME as PREG_MODULE, FETCH_CODES } from '@/store/preg/actions.type'
  import { checkUrl, noDropAndDropOver, $showModalWithErrorMsg, renameAndSetDtoProperty, $imgSuccessHandling, addProperty, removeProperty, $imgRemove, shareUrlToEmbedUrl, embedUrlToShareUrl, getMediaByShareUrl, acceptHandlingForDimensionLimit, thumbhnailHandlingForLimtDismension, acceptHandlingForDimensionLimitByObj } from '@/common/util'
  import { SHOW_MODAL } from '@/store/ui/mutations.type'
  import { mapGetters, mapMutations, mapState } from 'vuex'
  import { labelClasses, IMAGE_UPLOAD_URL, genreDesc } from '@/constants'
  import playGameService from '@/common/api/playGame.service'

  export default {
    components: {
      vueDropzone: vue2Dropzone
    },
    created () {
      // drop, dropOver 이벤트 막음
      noDropAndDropOver()
    },
    data () {
      return {
        osOptions: [
          {
            text: 'AOS',
            value: 'aos'
          },
          {
            text: 'iOS',
            value: 'ios'
          }
        ],
        osSelected: [],
        dateOptions: {
          format: 'YYYY-MM-DD HH:mm:ss',
          useCurrent: true
        },
        mediaSelected: {
          ko: 'kakaotv',
          en: 'kakaotv',
          ch: 'kakaotv',
          jp: 'kakaotv'
        },
        isOutLinkUrl: {
        },
        isUseSite: false,
        isUseSnackExeUrl: false,
        labelClasses: labelClasses,
        // dropzoneJs 옵션
        dropzoneOptions: {
          withCredentials: true,
          paramName: 'image',
          url: process.env.VUE_APP_BASE_URL + IMAGE_UPLOAD_URL,
          dictDefaultMessage: '파일을 선택해주세요.',
          dictRemoveFile: '삭제',
          thumbnailWidth: 250,
          thumbnailHeight: 250,
          thumbnailMethod: 'contain',
          addRemoveLinks: true,
          // maxFilesize: 0.4,
          dictFileTooBig: '파일 용량을 초과하였습니다. (최대 용량 : {{maxFilesize}}MB)',
          dictMaxFilesExceeded: '{{maxFiles}}개까지 업로드 가능합니다.',
          dictResponseError: '일시적으로 네트워크 오류가 있습니다. 삭제 후, 다시 시도해주세요.',
          acceptedFiles: 'image/gif, image/png, image/jpeg'
        },
        renameAndSetDtoProperty: renameAndSetDtoProperty,
        imgSuccessHandling: $imgSuccessHandling.bind(this),
        addProperty: addProperty,
        removeProperty: removeProperty,
        imgRemove: $imgRemove.bind(this),
        genreDesc: genreDesc
      }
    },
    mounted () {
      this.$store.dispatch(PREG_MODULE + FETCH_CODES)
        .catch($showModalWithErrorMsg.bind(this))
      this.$store.dispatch(PGM_MODULE + FETCH_PLAYGAME, this.$route.params.appMasterId)
        .then(()=> {
          embedUrlToShareUrl(this.playGameWithMoment.gameViewInfo.mediaLink)
          this.setMediaSelected(this.playGameWithMoment.gameViewInfo.mediaLink)

          if (this.playGameWithMoment.aos !== null) {
            this.osSelected.push('aos')
          }

          if (this.playGameWithMoment.ios !== null) {
            this.osSelected.push('ios')
          }

          this.$refs.appIcon.manuallyAddFile({
            pregDtoParam: {
              lang: '',
              name: 'appIcon',
              uploadUrl: this.playGameWithMoment.gameViewInfo.appIcon,
              isMultiple: false,
              imageObj: 'gameViewInfo',
            }}, this.playGameWithMoment.gameViewInfo.appIcon)
          if (this.playGameWithMoment.gameViewInfo.kakaoTalkShareImage !== '') {
            this.$refs.kakaoTalkShareImage.manuallyAddFile({
              pregDtoParam: {
                lang: '',
                name: 'kakaoTalkShareImage',
                uploadUrl: this.playGameWithMoment.gameViewInfo.kakaoTalkShareImage,
                isMultiple: false,
                imageObj: 'gameViewInfo',
              }}, this.playGameWithMoment.gameViewInfo.kakaoTalkShareImage)
          }

          if (this.playGameWithMoment.gameViewInfo.facebookShareImage !== '') {
            this.$refs.facebookShareImage.manuallyAddFile({
              pregDtoParam: {
                lang: '',
                name: 'facebookShareImage',
                uploadUrl: this.playGameWithMoment.gameViewInfo.facebookShareImage,
                isMultiple: false,
                imageObj: 'gameViewInfo',
              }}, this.playGameWithMoment.gameViewInfo.facebookShareImage)
          }


          for (let lang in this.playGameWithMoment.appNameInfo) {
            if (this.playGameWithMoment.appNameInfo[lang] != null) {
              if (this.playGameWithMoment.gameViewInfo.screenShot[lang] !== undefined && Array.isArray(this.playGameWithMoment.gameViewInfo.screenShot[lang])) {
                this.playGameWithMoment.gameViewInfo.screenShot[lang].forEach((elem)=> {
                  this.$refs['screenShot'+lang][0].manuallyAddFile({
                    pregDtoParam: {
                      lang: lang,
                      name: 'screenShot',
                      uploadUrl: elem.imageUrl,
                      isMultiple: true,
                      imageObj: 'gameViewInfo',
                    }}, elem.imageUrl)
                })
              }
            }
          }
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    computed: {
      checkSiteUrlValid() {
        return this.isUseSite?checkUrl(this.playGameWithMoment.gameViewInfo.siteUrl):true
      },
      checkSnackExeUrlValid() {
        return this.isUseSnackExeUrl?checkUrl(this.playGameWithMoment.gameViewInfo.snackGameExeUrl):true
      },
      aosEndIconLabelOptions () {
        return Object.assign({}, this.dateOptions, {minDate: this.playGameWithMoment.aos.osViewInfo.iconStartTime})
      },
      iosEndIconLabelOptions () {
        return Object.assign({}, this.dateOptions, {minDate: this.playGameWithMoment.ios.osViewInfo.iconStartTime})
      },
      ...mapGetters(PGM_MODULE, [
        'playGameWithMoment'
      ]),
      ...mapState('auth', ['auth']),
      ...mapGetters(PREG_MODULE, [
        'gameGradeOptionsForBootstrap',
        'iconLabelOptionsForBootstrap'
      ])
    },
    methods : {
      changeIsOutLinkUrl (market, event) {
        console.log(market, event)
        if (!event) {
          this.playGameWithMoment.marketInfo[market].outLinkUrl = ''
          this.playGameWithMoment.marketInfo[market].outLinkType = ''
        }
      },
      setMediaSelected (mediaLink) {
        this.mediaSelected = getMediaByShareUrl(mediaLink)
      },
      imgRemoveScreenshots (file) {
        const objDtoParam = file.pregDtoParam
        const foundIndex = this.playGameWithMoment[objDtoParam.imageObj][objDtoParam.name][objDtoParam.lang].findIndex(
          (elem)=> {
            return elem.imageUrl === objDtoParam.uploadUrl
          })
        if (foundIndex !== -1)
          this.playGameWithMoment[objDtoParam.imageObj][objDtoParam.name][objDtoParam.lang].splice(foundIndex, 1)
        else {
          console.error('찾을 수 없습니다.')
        }
      },
      hasAuthOfExposure () {
        return this.auth.authGroup.authGroupName === 'super'
      },
      submitHandling () {
        if (this.hasAuthOfExposure()) {
          if (this.playGameWithMoment.aos === null && this.playGameWithMoment.ios === null) {
            this[SHOW_MODAL]({msg: 'OS 노출을 설정해주세요.', okHandling: () => {}})
            return
          }
        }
        if (!this.checkSiteUrlValid || !this.checkSnackExeUrlValid) {
          this[SHOW_MODAL]({msg: (this.checkSiteUrlValid?'스낵게임 링크를':'공식사이트 링크를') + ' 확인해주세요.', okHandling: () => {}})
          return
        } else {
          if (!this.isUseSite) {
            this.playGameWithMoment.gameViewInfo.siteUrl = ''
          }
          if (!this.isUseSnackExeUrl) {
            this.playGameWithMoment.gameViewInfo.snackGameExeUrl = ''
          }
        }

        // 공유하기 url을 embed URL로 바꾼다.
        let langList = shareUrlToEmbedUrl(this.playGameWithMoment.gameViewInfo.mediaLink, this.mediaSelected);
        if (langList.length > 0) {
          alert('동영상 링크를 확인해주세요.');
          return;
        }

        Object.keys(this.playGameWithMoment.marketInfo).forEach(el => {
          if (this.playGameWithMoment.marketInfo[el].outLinkUrl === '') {
            this.playGameWithMoment.marketInfo[el].outLinkUrl = null;
          }
          if (this.playGameWithMoment.marketInfo[el].outLinkType === '') {
            this.playGameWithMoment.marketInfo[el].outLinkType = null;
          }
          if (this.isOutLinkUrl[el] === false) {
            this.playGameWithMoment.marketInfo[el].outLinkType = null;
            this.playGameWithMoment.marketInfo[el].outLinkUrl = null;
          }
        })
        // console.log('result:???')
        // console.log(this.playGameWithMoment)
        // return;
        playGameService.createPlayGame(this.playGameWithMoment)
          .then((res) => {
            this[SHOW_MODAL]({msg: '수정이 완료되었습니다.', okHandling: () => { this.$router.go(-1) }})
          })
          .catch((error) => {
            embedUrlToShareUrl(this.playGameWithMoment.gameViewInfo.mediaLink)
            if (error.response.data.msg) {
              this[SHOW_MODAL]({msg: error.response.data.msg, okHandling: () => {}})
            } else {
              throw error
            }
          })
          .catch($showModalWithErrorMsg.bind(this))
      },
      imgHandlingTemplate (file, fn) {
        const objDtoParam = file.pregDtoParam
        console.log('---imghnadlingaTmeplatge')
        console.log(file)
        console.log(fn)
        console.log('---imghnadlingaTmeplatge')

        if (objDtoParam.lang === undefined || objDtoParam.lang === '') {
          console.log('imgage Handling in if')
          console.log(this.playGameWithMoment.gameViewInfo)
          console.log(objDtoParam.obj)
          console.log(objDtoParam.obj == this.playGameWithMoment.gameViewInfo )
          console.log('imgage Handling in if')
          fn(this.playGameWithMoment[objDtoParam.imageObj], objDtoParam.name, objDtoParam.uploadUrl)
        } else {
          fn(this.playGameWithMoment[objDtoParam.imageObj][objDtoParam.name], objDtoParam.lang,
            {
              order: this.playGameWithMoment[objDtoParam.imageObj][objDtoParam.name][objDtoParam.lang].length + 1,
              imageUrl: objDtoParam.uploadUrl
            })
        }
      },
      acceptHandlingForDimensionLimit: acceptHandlingForDimensionLimit,
      acceptHandlingForDimensionLimitByObj: acceptHandlingForDimensionLimitByObj,
      thumbhnailHandlingForLimtDismension: thumbhnailHandlingForLimtDismension,
      ...mapMutations('ui', [SHOW_MODAL]),
      ...mapMutations(PGM_MODULE, ['testA'])
    },
    watch : {
      osSelected (osSelected) {
        const defaultValue = {
          aos: {
            osType: 'android',
            appStartTime: null,
            orderTime: null,
            displayYn: false,
            displayStartTime: null,
            viewInfo: {
              iconLabel: '',
              iconStartTime: null,
              iconEndTime: null,
              searchYn: false
            }
          },
          ios: {
            osType: 'ios',
            appStartTime: null,
            orderTime: null,
            displayYn: false,
            displayStartTime: null,
            viewInfo: {
              iconLabel: '',
              iconStartTime: null,
              iconEndTime: null,
              searchYn: false
            }
          }
        }
        const allOsTypes = ['ios', 'aos']
        console.log('--osSelected')
        console.log(osSelected)
        console.log('--osSelected')

        for (let i = 0; i < allOsTypes.length; i++) {
          if(!osSelected.includes(allOsTypes[i])) {
            this.playGameWithMoment[allOsTypes[i]] = null
          }
        }

        for (let i = 0; i < osSelected.length; i++) {
          // default 값 초기화
          if (this.playGameWithMoment[osSelected[i]] === null ) {
            this.playGameWithMoment[osSelected[i]] = JSON.parse(JSON.stringify(defaultValue[osSelected[i]]))
          }
        }
      },
      isUseSite (newVal, oldVal) {
        if (newVal === false) {
          this.playGameWithMoment.gameViewInfo.siteUrl = ''
        }
      },
      isUseSnackExeUrl (newVal, oldVal) {
        if (newVal === false) {
          this.playGameWithMoment.gameViewInfo.snackGameExeUrl = ''
        }
      },
      'playGameWithMoment.marketInfo': {
        handler (newVal, oldVal) {
          Object.keys(newVal).forEach(el => {
            if (this.isOutLinkUrl[el] === undefined) {
              this.$set(this.isOutLinkUrl, el, false)
            }
            if (newVal[el].outLinkUrl != null && newVal[el].outLinkUrl !== '') {
              this.isOutLinkUrl[el] = true;
            }
          })
        },
        immediate: true,
        deep: true
      },
      'playGameWithMoment.gameViewInfo.siteUrl': {
        handler (newVal, oldVal) {
          if (newVal != null && newVal !== '') {
            this.isUseSite = true
          } else {
            this.isUseSite = false
          }
        },
        immediate: true
      },
      'playGameWithMoment.gameViewInfo.snackGameExeUrl': {
        handler (newVal, oldVal) {
          console.log(typeof newVal)
          if (newVal != null && newVal !== '') {
            this.isUseSnackExeUrl = true
          } else {
            this.isUseSnackExeUrl = false
          }
        },
        immediate: true
      }
    }
  }
</script>
<style scoped>
  .columnWidth {
    width: 200px !important;
  }
</style>
